import {
    useEffect,
    useState,
} from 'react'

// Turns on only after `flag` has stayed true for `delay` ms; turns off immediately.
const useDelayedFlag = (flag: boolean, delay: number): boolean => {
    const [
        isDelayElapsed,
        setIsDelayElapsed,
    ] = useState(false)

    useEffect(() => {
        if (!flag) {
            setIsDelayElapsed(false)
            return undefined
        }

        const timer = setTimeout(() => {
            setIsDelayElapsed(true)
        }, delay)

        return () => {
            clearTimeout(timer)
        }
    }, [
        flag,
        delay,
    ])

    return flag && isDelayElapsed
}

export default useDelayedFlag
